import React, { useEffect, useState } from 'react'
import './landing.css'
// import './outer.css'
import { Link,useNavigate } from 'react-router-dom'
import { RiCustomerService2Fill } from 'react-icons/ri'
import logo from '../../images/transLogo.svg'
import safty from "../../images/security.svg"
import { Button, Form, Modal, Input } from 'antd';
// import { coupleSlider } from '../../data.js'
import { UserOutlined, SecurityScanOutlined } from '@ant-design/icons';
import Register from '../Authentication/Register'
import { useCookies } from 'react-cookie'
import { useDispatch, useSelector } from 'react-redux';
import { loginUser } from '../../Redux/features/User/userSlice'
import ForgetPassword from '../Authentication/ForgetPassword'
// import OtpLogin from '../Authentication/OtpLogin'




const Landing = () => {
    //eslint-disable-next-line
    const [cookies, setCookie, removeCookie] = useCookies(['x-auth-token']);
    const navigate = useNavigate()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isRegisterModalOpen, setIsRegisterModalOpen] = useState(false);
    const [isForgetPasswordModalOpen, setIsForgetPasswordModalOpen] = useState(false);
    // const [isOtpLoginModalOpen, setIsOtpLoginModalOpen] = useState(false);
    const dispatch = useDispatch();
    const token = useSelector((state) => state.user.token);

    useEffect(() => {
        if (token) {
            setCookie('x-auth-token', token, {
                path: '/',
                maxAge: 60 * 60 * 24 * 7 * 4 * 12,
                sameSite: true,
            });
            setIsModalOpen(false)
        }
        //eslint-disable-next-line
    }, [token])

    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
        setIsRegisterModalOpen(false);
        // setIsOtpLoginModalOpen(false);
        setIsForgetPasswordModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
        setIsRegisterModalOpen(false);
        // setIsOtpLoginModalOpen(false);
        setIsForgetPasswordModalOpen(false);
    };
    const handleLogin = (values) => {
        dispatch(loginUser(values))
    }
    const handleSignUp = () => {
        setIsModalOpen(false)
        setIsRegisterModalOpen(true)
    }
    // const openOtpLogin = () => {
    //     setIsOtpLoginModalOpen(true)
    //     setIsModalOpen(false)
    // }
    const openForgetPassword = () => {
        setIsForgetPasswordModalOpen(true)
        setIsModalOpen(false)
    }

    return (
        <div className='landing'>
            <Modal open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <div className='login container'>
                    <div className="logo">
                        <img src={logo} alt="LovodiSite" />
                    </div>
                    <div className="loginHeading">Welcome back! Please Login</div>
                    <div className="loginForm">
                        <Form layout="vertical" onFinish={handleLogin}>
                            <Form.Item label="Email" name="email" rules={[{ required: true, message: 'Please input your email!' }]}>
                                <Input prefix={<UserOutlined className="site-form-item-icon" />} type="email" placeholder="Email" />
                            </Form.Item>
                            <Form.Item label="Password" name="password" rules={[{ required: true, message: 'Please input your password!' }]}>
                                <Input.Password prefix={<SecurityScanOutlined className="site-form-item-icon" />} placeholder="Password" />
                            </Form.Item>

                            <div className='forgetPassword'>
                                <Link onClick={openForgetPassword} className="forgotPassword">Forgot Password?</Link>
                            </div>

                            <Button style={{ width: "100%" }} type="primary" htmlType="submit" className="loginBtn">
                                Login
                            </Button>
                        </Form>
                        {/* <div className='d-flex justify-content-center mb-3 fw-bold'>OR</div> */}
                        {/* <div>
                            <Button onClick={openOtpLogin} style={{ width: "100%" }} type='primary'>Login with OTP</Button>
                        </div> */}
                        <div className="loginFooterText">New to Lovodi.com?
                            <Link onClick={handleSignUp}>Sign Up Free</Link>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal width={1000} open={isRegisterModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <Register />
            </Modal>
            <Modal width={1000} open={isForgetPasswordModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <ForgetPassword />
            </Modal>
            {/* <Modal width={1000} open={isOtpLoginModalOpen} onOk={handleOk} onCancel={handleCancel}>
                <OtpLogin />
            </Modal> */}
            <div className="landing-page">
                <div className="navbar">
                    <Link className="logo" to="/">
                        <img src={logo} alt="lovodi" />
                    </Link>
                    <div className="nav-links">
                        <ul>
                            <li className='mt-2'><Link style={{ color: "#fff" }} onClick={showModal} >Login</Link></li>
                            <li onClick={()=>navigate("/contact-us")} className='customerIcon'><RiCustomerService2Fill size={30} />&nbsp;Help</li>
                        </ul>
                    </div>
                </div>
                <div className='coverText'>
                    <div className='headinggggg'>Only Matrimonial and Dating Site you can Trust</div>
                    <button onClick={() => setIsRegisterModalOpen(true)} className='btnnnn'>Find Match Now</button>

                </div>
            </div>
            <h3 className='text-center safety-body-head'>Trust and safety</h3>
            <div className="d-flex container safety">
                <img
                    alt="lovodi"
                    src={safty}
                />
                <div className="safety-body">
                    <p>
                        We want Match to be a fun, safe online dating site where you can meet
                        serious, committed singles ready for a real relationship. The safety of
                        our clients is our top priority, and we work hard to keep our site safe.
                        We moderate every single profile picture and description on our site, and
                        the protection of your personal data is our priority.
                    </p>
                    <p>
                        Plus if you ever feel uncomfortable about a profile or a message you
                        receive you can always block or report a member to our moderators. They’ll
                        be happy to help. We also have lots of tips about making sure you stay
                        safe while you’re using our site and when you decide it’s time to meet in
                        real life. Just take a look in our help centre.
                    </p>
                </div>
            </div>


            <div className='backgroundLight'>
                <div className='heading pt-4' >Matrimony Service with Millions of Success Stories</div>
                <div className="section landing-bg-grey testimonial-section p4 center">
                    <div className="d-flex justify-content-center">
                        <div className="testimonial col-2 center mx3">
                            <Link to="/">
                                <img src="https://th.bing.com/th/id/OIP.riFK0d7yTgzeh0-CLNqgVwHaFL?pid=ImgDet&rs=1" className="circle border overflow-hidden" alt='lovodi-testimonial' />
                                <h4>"It was as though we'd known each other for years."</h4>
                                <p className="grey">Raj</p>
                            </Link>
                        </div>

                        <div className="testimonial col-2 center mx3">
                            <Link to="/">
                                <img src="https://th.bing.com/th/id/OIP.Yb9cvJNbKrWKqZqNiQGdqAHaE7?pid=ImgDet&rs=1" className="circle border overflow-hidden" alt='lovodi-testimonial' />
                                <h4>"I met my ideal partner! I feel like the happiest woman. "</h4>
                                <p className="grey">Dikhsit</p>
                            </Link>
                        </div>

                        <div className="testimonial col-2 center mx3">
                            <Link to="/">
                                <img src="https://th.bing.com/th/id/OIP.ILPaBFO8Yo22oGPzbIobHQHaFj?pid=ImgDet&rs=1" className="circle border overflow-hidden" alt='lovodi-testimonial' />
                                <h4>"I found the love of my life on this site."</h4>
                                <p className="grey">Jemima</p>
                            </Link>
                        </div>

                        <div className="testimonial col-2 center mx3">
                            <Link to="/">
                                <img src="https://th.bing.com/th/id/OIP.l-6AojZAseFO14-06ZNlBgHaHz?pid=ImgDet&rs=1" className="circle border overflow-hidden" alt='lovodi-testimonial' />
                                <h4>" I moved to Holland with him! We are overjoyed."</h4>
                                <p className="grey">Ramis</p>
                            </Link>
                        </div>

                    </div>
                    <div className="read-testimonial-btn">
                        <Link className="header-color inline-block" to="/">
                            Read Testimonials
                        </Link>
                    </div>
                </div>
            </div>

            <div className='backgroundLight py-4'></div>
            <div className='container mb-3 mt-3'>
                <div className="heading">
                    Find your Match Right Now
                </div>
                <div className="row">
                    <div className="col-sm-4 text-center">
                        <Link title="Create your Matrimony Profile" onClick={() => setIsRegisterModalOpen(true)} className="sign_up">
                            <span className="sign_up_span"></span>
                        </Link>
                        <div className="featuresItem">
                            <Link id="sign_up_link" className="FeaturesItemLink2" onClick={() => setIsRegisterModalOpen(true)}>Sign Up</Link>
                            <div>Register for free &amp; put up your Matrimony Profile</div>
                        </div>
                    </div>
                    <div className="col-sm-4 text-center">
                        <Link title="Connect with Matrimony Profiles" onClick={() => setIsRegisterModalOpen(true)} className="connect">
                            <span className="connect_span"></span>
                        </Link>
                        <div className="featuresItem">
                            <Link className="FeaturesItemLink2" onClick={() => setIsRegisterModalOpen(true)}>Connect</Link>
                            <div>Select &amp; Connect with Matches you like</div>
                        </div>
                    </div>
                    <div className="col-sm-4 text-center">
                        <Link title="Become a Premium Member &amp; Find Matrimony Profiles" onClick={() => setIsRegisterModalOpen(true)} className="interact">
                            <span className="FeaturesItemLink"></span>
                        </Link>
                        <div className="featuresItem">
                            <Link className="FeaturesItemLink2" onClick={() => setIsRegisterModalOpen(true)}>Interact</Link>
                            <div>Become a Premium Member &amp; Start a Conversation</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='aboutLovodi backgroundLight'>
                <div className='container'>
                    <div className='logo'>
                        <img src={logo} alt='lovodi' />
                    </div>
                    <div className='description'>
                        <Link>Lovodi.com</Link> is a premier matrimonial website that has revolutionized the way people find their life partners. It is a trusted platform that brings together individuals from diverse backgrounds and communities, all in pursuit of love, companionship, and lifelong commitment. With its user-friendly interface and advanced search features, Lovodi.com makes the process of finding a suitable match simple and convenient. Whether you're looking for a life partner based on shared values, cultural preferences, or specific criteria, the platform provides a wide range of options to explore. The website offers a comprehensive and secure environment where users can create detailed profiles, highlighting their personal information, educational background, career details, interests, and <Link style={{ fontWeight: "bold" }}>Many More</Link>.
                    </div>
                </div>
            </div>
            <div className="StickyBanner_getStartedWrapper__Ek_uQ">
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 StickyBanner_storyHeading__LTDaw">Your story is waiting to happen!
                            <Link onClick={() => setIsRegisterModalOpen(true)} className="StickyBanner_getStartedBtn__Li6kN">Get Started</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Landing
